export enum ReservedInventoryBucketKind {
  Reserved = "reserved",
  Damaged = "damaged",
  Preorder = "preorder",
  Oversell = "oversell",
}
